import React from 'react';
import { createUseStyles } from 'react-jss';

function SessionDetailModalTitle() {
  const classes = useStyles();

  return <div className={classes.container}>Revise o Pedido</div>;
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid red',
  },
});

export { SessionDetailModalTitle };
